import { Tenant, Log, LogError } from '@ekuaibao/collection-definition';
import Standard from './Standard';
var models = [Tenant, Standard, Log, LogError];
export default models;
